import { Grid2 } from "@mui/material";
import StatusRowItem from "./StatusRowItem.js";

export default function StatusRow({ items }) {
  return (
    <Grid2 container={true} direction={'row'} size={12} spacing={2} justifyContent={'center'} alignItems={'center'}>
      {items.map((item, key) => (
        <StatusRowItem key={key}>{item}</StatusRowItem>
      ))}
    </Grid2>
  );
}
